const CheckValueChanged = (init: any, updated: any) => {
  if (init === updated) {
    return true;
  }

  if (!init || !updated) {
    return init === updated;
  }

  try {
    if (typeof init !== "object" || typeof updated !== "object") {
      return init === updated;
    }
    return JSON.stringify(init) === JSON.stringify(updated);
  } catch (error) {
    console.error("Error comparing values:", error);
    return false;
  }
};

export default CheckValueChanged;
